import { render, staticRenderFns } from "./markets.vue?vue&type=template&id=9fc128ee"
import script from "./markets.vue?vue&type=script&lang=js"
export * from "./markets.vue?vue&type=script&lang=js"
import style0 from "./markets.vue?vue&type=style&index=0&id=9fc128ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports